import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { PreferenceProvider, UserProvider } from './context/UserContext';




// import 'https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700&amp;display=swap';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <PreferenceProvider>
     <App/>  
    </PreferenceProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//////console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
